import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { TDoctor, TDoctorSetting } from '../types/doctor';
import { getActiveDoctors,getAllDoctorsSettings,getUnApprovedDoctors } from '../services/indexedDB';

export const fetchDoctors = createAsyncThunk(
  'doctor/fetchDoctors',
  async () => {
    try {
      let res = await getActiveDoctors();
      return res;
    } catch (err) {
      return null;
    }
  }
);

export const fetchUnApprovedDoctors = createAsyncThunk(
  'doctor/fetchUnApprovedDoctors',
  async () => {
    try {
      let res = getUnApprovedDoctors();
      return res;
    } catch (err) {
      return null;
    }
  }
);

export const fetchDoctorSettings = createAsyncThunk(
  'doctor/fetchDoctorSettings',
  async () => {
    try {
      let res = await getAllDoctorsSettings();
      return res;
    } catch (err) {
      return [];
    }
  }
);
export interface IdoctorInitialState {
  doctors: TDoctor[] | null;
  un_approved_doctors: TDoctor[] | null;
  doctor_settings: TDoctorSetting[];
}
const doctorInitialState: IdoctorInitialState = {
  doctors: null,
  doctor_settings: [],
  un_approved_doctors: null,
};
const doctor = createSlice({
  name: 'doctor',
  initialState: doctorInitialState,
  reducers: {
    setDoctors: (state, action: PayloadAction<TDoctor[]>) => {
      state.doctors = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(
      fetchDoctors.fulfilled,
      (state, action: PayloadAction<TDoctor[] | null>) => {
        state.doctors = action.payload;
      }
    );
    builder.addCase(
      fetchDoctorSettings.fulfilled,
      (state, action: PayloadAction<TDoctorSetting[]>) => {
        state.doctor_settings = action.payload;
      }
    );
    builder.addCase(
      fetchUnApprovedDoctors.fulfilled,
      (state, action: PayloadAction<TDoctor[] | null>) => {
        state.un_approved_doctors = action.payload;
      }
    );
  },
});
export const { setDoctors } = doctor.actions;
export default doctor.reducer;
